import { useContext } from "react";
import { UserContext } from "../../Provider";
import { RolesHandleProps, VendorRolesHandleProps } from "./rolesHandleProps.props";

export const RolesHandle = ({
    roles,
    illegal,
    firmId,
    fkOrgId,
    bypassIndividualIds,
    ...props
}: RolesHandleProps) => {
    const user = useContext(UserContext);

    if (user?.orgType === 4 || user?.orgType === 5) return null;

    if (user && user.roles.some(e => e === "Admin")) {
        return props.children;
    }
    if (user?.individual.fkOrgId === firmId) {

        if (bypassIndividualIds && bypassIndividualIds.some(e => e === user?.individual.individualId)) {
            return props.children;
        }

        if (user && user.roles.filter(e => roles.includes(e)).length > 0) {
            return props.children;
        }

        return illegal ? illegal : null;
    }

    if (bypassIndividualIds && bypassIndividualIds.some(e => e === user?.individual.individualId)) {

        return props.children;
    }

    return illegal ? illegal : null;
}

export const RolesHandleAdmin = ({
    roles,
    illegal,
    firmId,
    fkOrgId,
    bypassIndividualIds,
    ...props
}: RolesHandleProps) => {
    const user = useContext(UserContext);

    if (user && user.roles.some(e => e === "Admin")) {
        return props.children;
    }
    if (user?.individual.fkOrgId === firmId) {
        if (bypassIndividualIds && bypassIndividualIds.some(e => e === user?.individual.fkIndividualId)) {
            return props.children;
        }

        if (user && user.roles.filter(e => roles.includes(e)).length > 0) {
            return props.children;
        }

        return illegal ? illegal : null;
    }

    if (bypassIndividualIds && bypassIndividualIds.some(e => e === user?.individual.fkIndividualId)) {
        return props.children;
    }

    return illegal ? illegal : null;
}

export const RolesHandleInquiries = ({
    roles,
    illegal,
    firmId,
    fkOrgId,
    bypassIndividualIds,
    ...props
}: RolesHandleProps) => {
    const user = useContext(UserContext);

    if (user?.orgType === 4 || user?.orgType === 5) return null;

    if (user && user.roles.filter(e => roles.includes(e)).length > 0) {
        return props.children;
    } else {
        return props.children;
    }
}

export const RolesVendor = ({
    roles,
    illegal,
    fkOrgId,
    bypassIndividualIds,
    isDetail,
    ...props
}: VendorRolesHandleProps) => {
    const user = useContext(UserContext);

    if (!isDetail && user && user.roles.some(e => e === "Admin")) {
        return props.children;
    }

    if (user?.individual.fkOrgId === fkOrgId) {

        if (user?.orgType === 4 || user?.orgType === 5) return props.children;
    }

    return illegal ? illegal : null;
}

export const isRolesVendor = ({
    currentUser,
    fkOrgId,
    isDetail
}: VendorRolesHandleProps) => {

    if (!isDetail && currentUser && currentUser.roles.some(e => e === "Admin")) {
        return true;
    }

    if (currentUser?.individual.fkOrgId === fkOrgId) {
        if (currentUser?.orgType === 4 || currentUser?.orgType === 5) return true;
    }

    return false;
}